<div class="new-card">
  <div class="content">
    <div class="faq-header">
      ZestMoney credit FAQs
    </div>
    <div class="faq-container">
      <div class="faq-list">
        <ul materialize="collapsible" class="collapsible" data-collapsible="accordion">
          <li *ngFor="let faq of faqs; let i = index">
            <div class="collapsible-header">
              <div class="question" [innerHTML]="((i + 1) + '. ' + faq.question) | safeHtml"></div>
            </div>
            <div class="collapsible-body" [innerHTML]="faq.answer | safeHtml"></div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>